import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Advertiser, CampaignsAdvertiserAdminApiClient } from 'src/app/api/api-campaigns.service.generated';
import { PERMISSION } from 'src/app/const/permission';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { AdvertiserDetailsComponent } from '../advertiser-details/advertiser-details.component';
import { HasAnyPermissionDirective } from 'src/app/common/directives/has-any-permission/has-any-permission.directive';
import { BreadcrumbsComponent, ButtonComponent, PageContainerComponent } from 'wecheer-common';
import { ScreenService } from 'src/app/common/services/screen.service';
import { AppVersionService } from 'src/app/common/services/app-version.service';
import { AsyncPipe } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { AdvertiserCampaignsComponent } from '../advertiser-campaigns/advertiser-campaigns.component';
import { UserPermissionsService } from 'src/app/common/services/user-permissions.service';

@Component({
  selector: 'app-advertiser-page',
  templateUrl: './advertiser-page.component.html',
  styleUrls: ['./advertiser-page.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatCardModule,
    MatTabsModule,
    AsyncPipe,
    AdvertiserDetailsComponent,
    AdvertiserCampaignsComponent,
    HasAnyPermissionDirective,
    PageContainerComponent,
    ButtonComponent,
    BreadcrumbsComponent
  ]
})
export class AdvertiserPageComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private client = inject(CampaignsAdvertiserAdminApiClient);
  private userPermissionsService = inject(UserPermissionsService);
  screen = inject(ScreenService);
  appVersion = inject(AppVersionService);


  // @ViewChild('advertiserOutlets') advertiserOutlets: AdvertiserOutletsComponent;

  advertiser: Advertiser;
  isLoading = true;
  advertiserId: string;
  isBrandAdmin = false;
  readonly permissions = PERMISSION;

  constructor() {
    this.advertiserId = this.route.snapshot.paramMap.get('id');
  }

  get loading(): boolean {
    return this.screen.isLoading();
  }

  ngOnInit() {
    this.onRefresh();
    this.userPermissionsService.hasPermission(PERMISSION.BRANDADMIN).subscribe(isBrandAdmin => this.isBrandAdmin = isBrandAdmin);
  }

  async onRefresh() {
    this.advertiser = await lastValueFrom(this.client.getAdvertiserById(this.advertiserId));
  }


  onSettings(advertiser: Advertiser) {
    this.router.navigate(['/advertisers', advertiser.id, 'settings']);
  }

  onMigrationCampaigns() {
    this.router.navigate(['/advertisers', this.advertiserId, 'migration-campaigns']);
  }

}

